var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeshorts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-youtube-shorts 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5 9L15.5 12L10.5 15V9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.61274 22C6.14374 22 4.13574 19.991 4.13574 17.522C4.13574 16.151 4.75174 14.887 5.79074 14.045C4.77074 13.219 4.13574 11.96 4.13574 10.567C4.13574 8.9 5.05374 7.381 6.53174 6.605L14.2617 2.535C14.9027 2.188 15.6417 2 16.3867 2C18.8557 2 20.8637 4.009 20.8637 6.478C20.8637 7.849 20.2477 9.113 19.2087 9.955C20.2287 10.781 20.8637 12.04 20.8637 13.433C20.8637 15.143 19.8677 16.727 18.3257 17.468L10.7367 21.465C10.1027 21.812 9.36274 22 8.61274 22Z",
    stroke: "black",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeshorts);
export default __webpack_public_path__ + "static/media/youtubeshorts.af869af78359b4acc79c0a500abe8d81.svg";
export { ForwardRef as ReactComponent };